<ion-header>
  <ion-toolbar color="primary" class="PhotoCarouselModal__Header">
    <ion-title> {{ activeSlideIndex + 1 }} of {{ photos.length }} </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div>
    <!-- Carousel -->
    <smartflip-photo-carousel
      [photos]="photos"
      (activeSlideIndexChange)="updateActiveIndex($event)"
      [initialSlideIndex]="2"
      [fullScreen]="true"
    ></smartflip-photo-carousel>
  </div>
</ion-content>
